import type { RecipeRecord } from '@/types/domain';
import { SaveManager } from './SaveManager';

export const RecipeRepository = {
  async get(key: string): Promise<RecipeRecord | undefined> {
    return SaveManager.getRecipe(key);
  },
  async save(record: RecipeRecord): Promise<void> {
    await SaveManager.putRecipe(record);
  },
  async all(): Promise<RecipeRecord[]> {
    const all = await SaveManager.allRecipes();
    return all.sort((a, b) => b.createdAt - a.createdAt);
  },
  async recent(limit = 24): Promise<RecipeRecord[]> {
    return (await this.all()).slice(0, limit);
  },
  /** Clear cached AI (non-vanilla) recipe records so they regenerate on next craft. */
  async clearCache(): Promise<{ cleared: number }> {
    const all = await SaveManager.allRecipes();
    let n = 0;
    for (const r of all) {
      if (!r.isVanilla) {
        await SaveManager.deleteRecipe(r.key);
        n++;
      }
    }
    return { cleared: n };
  },
};
